<script setup>
import TransitionSlideDown from '@/components/TransitionSlideDown.vue';
import { inject, onMounted, watch } from 'vue';
const { toggle, open: menuOpen } = inject('main-navigation')
const open = defineModel('open', { type: Boolean, default: false })

watch(menuOpen, (menuOpen) => { open.value = menuOpen }, { immediate: true })
</script>

<template>
    <Teleport to="body">
        <TransitionSlideDown>
            <aside v-if="open" class="menu-flyout" role="dialog">
                <div class="menu-flyout__scroll-container">
                    <slot />
                </div>
            </aside>
        </TransitionSlideDown>
    </Teleport>
</template>

<style lang="scss">
@use "@bam/scss" as *;
@use "@/scss/helpers/grid" as *;
@use "@/scss/helpers/clamped" as *;

:root {
    --menu-flyout-background-color: #{v(color-dark)};
}

.menu-flyout {
    position: fixed;
    inset: 0;
    z-index: 99;
    width: 100vw;
    height: 100dvh;
    background: var(--menu-flyout-background-color);
    // background-blend-mode: soft-light;
    // backdrop-filter: blur(100px);
    overscroll-behavior: contain;

    &__scroll-container {
        @include adjusted-grid();
        height: 100%;
        width: 100%;

        padding-top: calc(#{v(header-height)} + #{clamped(40px, 68px)});
        padding-bottom: clamped(40px, 68px);
        overflow: clip scroll;
        display: grid;
    }

    &::after {
        content: "";
        display: flex;
        position: absolute;
        inset: auto 0 0 0;
        width: 100%;
        height: 30px;
        background: v(color-forest) url("/app-assets/eug_grunge.png"), color-mix(in srgb, v(color-dark) 50%, transparent);
        background-blend-mode: multiply, normal;
        mix-blend-mode: normal;
        z-index: 1;
    }
}
</style>
